import { useEffect, useState } from 'react';

import { Container } from '@mui/material';

import MuiDialog from 'components/MuiDialog';
import {
  SurveyDialogProps,
  TCoreNursingSkillVideoDefaultValues as TCoreNursingSkillVideoDeExemplefaultValues,
} from 'routes/Main/Survey/type';

import StudentModeInfoExemple from './StudentModeInfoExemple';

const CoreNursingSkillVideoExemple = (
  props: SurveyDialogProps<TCoreNursingSkillVideoDeExemplefaultValues>
) => {
  const [totalSize, setTotalSize] = useState(0);

  const { title, isOpen, onClose } = props;

  return (
    <MuiDialog.SurveyFormTwo title={title} isOpen={isOpen} onClose={onClose}>
      <Container sx={{ mt: 7.5, mb: 6 }}>
        <StudentModeInfoExemple totalSize={totalSize} />
      </Container>
    </MuiDialog.SurveyFormTwo>
  );
};

export default CoreNursingSkillVideoExemple;
